import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import SourceDatabaseService from '../../services/SourceDatabaseService';
import { useNavigate, useParams } from 'react-router-dom';

const SourceDatabaseEdit = () => {
  const [formData, setFormData] = useState({
    host: '',
    port: '',
    database_name: '',
    username: '',
    password: '',
  });
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetchSourceDatabase();
  }, []);

  const fetchSourceDatabase = async () => {
    try {
      const data = await SourceDatabaseService.get(id);
      setFormData({
        host: data.host || '',
        port: data.port || '',
        database_name: data.database_name || '',
        username: data.username || '',
        password: '', // Keep password empty initially for security
      });
    } catch (error) {
      console.error('Error fetching source database:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await SourceDatabaseService.update(id, formData);
      Swal.fire('Updated!', 'Source database updated successfully.', 'success');
      navigate('/source-databases'); // Redirect back to the source database list
    } catch (error) {
      console.error('Error updating source database:', error);
      Swal.fire('Error!', 'An error occurred while updating the source database.', 'error');
    }
  };

  const handleCancel = () => {
    navigate('/source-databases'); // Redirect back to the source database list
  };

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Edit Source Database</h4>
              <p className="card-description">Modify source database details</p>

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="host">Host</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="host"
                    name="host"
                    value={formData.host}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="port">Port</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="port"
                    name="port"
                    value={formData.port}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="database_name">Database Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="database_name"
                    name="database_name"
                    value={formData.database_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="username">Username</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="username"
                    name="username"
                    value={formData.username}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    className="form-control form-control-sm"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    placeholder="Leave empty to keep existing password"
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-sm mr-2">Update</button>
                <button type="button" className="btn btn-light btn-sm" onClick={handleCancel}>Cancel</button>
              </form>
            </div>
            <div className="card-footer text-muted">
              Please modify the source database details and click Update to save changes.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SourceDatabaseEdit;
